var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStopPublishing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 45492"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99935 0.855469C4.24343 0.855469 0.353516 4.74538 0.353516 9.5013C0.353516 14.2572 4.24343 18.1471 8.99935 18.1471C13.7553 18.1471 17.6452 14.2572 17.6452 9.5013C17.6452 4.74538 13.7553 0.855469 8.99935 0.855469ZM2.02018 9.5013C2.02018 5.61139 5.10944 2.52214 8.99935 2.52214C12.8893 2.52214 15.9785 5.61139 15.9785 9.5013C15.9785 13.3912 12.8893 16.4805 8.99935 16.4805C5.10944 16.4805 2.02018 13.3912 2.02018 9.5013Z",
    fill: "#4B4AD5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.625 6.375H7.375C6.54657 6.375 5.875 7.04657 5.875 7.875V11.125C5.875 11.9534 6.54657 12.625 7.375 12.625H10.625C11.4534 12.625 12.125 11.9534 12.125 11.125V7.875C12.125 7.04657 11.4534 6.375 10.625 6.375Z",
    fill: "#4B4AD5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopPublishing);
export default __webpack_public_path__ + "static/media/stop-publishing.687d843c9ef387c720345327d82ff791.svg";
export { ForwardRef as ReactComponent };